// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"18":"cb3faf22","98":"fe680aea","121":"a744479d","400":"707c8949","748":"25f5f73b","893":"e10a90f6","981":"a03d89d6"}[chunkId] + ".chunk.css";
};